import $foreign from "./foreign.cjs";
var add = $foreign.add;
var drain = $foreign.drain;
var $$new = $foreign.new;
export { add, drain, $$new as new };
